module.exports = __webpack_public_path__ + "files/5bc70cc781bb5dde886ab8499e9b5c6f.png";